import React from 'react';
import injectSheet from 'react-jss';

interface Props {
  style?: any;
  size?: 'default' | 'small';
  classes: any;
}

function Divider({ classes, style, size = 'default' }: Props) {
  return <div className={classes.divider} style={{ ...style, width: size === 'small' && 80 }} />;
}

const styles = theme => {
  return {
    divider: {
      borderBottom: `1px solid ${theme.palette.common.divider}`,
      margin: theme.spacing.unit * 3,
      paddingLeft: theme.spacing.unit * 3,
      paddingRight: theme.spacing.unit * 3,
      marginLeft: 'auto',
      marginRight: 'auto',
      width: 300,
    },
  };
};

export default injectSheet(styles)(Divider);
